<template>
  <div class="box">
    <tablePackaging
      :tableListData="postList"
      :tableOption.sync="tableOption"
      :isOperate="isOperate"
      :page="page"
      :searchFormList="searchFormList"
      @update="getTableChangePageData"
      @searchDate="getTableData"
    >
      <template v-slot:header>
        <div class="btn-wrap">
          <div class="left-wrap"></div>
          <div class="right-wrap">
            <el-button type="primary" @click="handelClickAdd" size="small"
              >添加</el-button
            >
          </div>
        </div>
      </template>
      <template slot-scope="scope" slot="operate">
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="编辑"
          placement="bottom-end"
        >
          <!-- v-if="scope.row.username != 'admin'" -->
          <el-button
            icon="el-icon-edit-outline"
            circle
            size="20"
            type="success"
            @click="handelClickEdit(scope.row)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="删除"
          placement="bottom-end"
        >
          <el-button
            icon="el-icon-delete"
            circle
            type="success"
            @click="handleDelete(scope.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </tablePackaging>
    <applicantAdd
      ref="applicantAdd"
      :informationBid="informationBid"
      :title="title"
      @upData="getTableData"
    ></applicantAdd>
  </div>
</template>

<script>
import {
  visaApplicantInformationQuery,
  visaApplicantInformationDelete,
} from '@/api/home';
import tablePackaging from '@/components/tablePackaging';
import applicantAdd from './components/applicantAdd';
import { clone } from '@/utils/utils';
const defaultSearchObj = {
  pageNum: 1,
  pageSize: 10,
  title: '',
};
export default {
  data() {
    return {
      title: '新建资料',
      informationBid: '',
      SearchObj: clone(defaultSearchObj),
      postList: [],
      searchFormList: [
        // {
        //   lable: '标题', //请输入 + lable
        //   searchItem: 'title', //字段名
        //   type: 'input', //输入框类型
        //   value: '', //默认值
        // },
      ],
      isOperate: true,
      tableOption: [
        //是否展示多选
        // {
        //   type: 'selection',
        //   label: '#',
        // },
        {
          prop: 'title',
          label: '标题',
          overHidden: true,
          //sortable: 'orgName',
        },
        {
          otherType: 'titlePictureUrl',
          prop: 'imageUrl',
          label: '背景图',
          overHidden: true,
          //sortable: 'orgName',
        },
        {
          prop: 'resourceName',
          label: '关联国家',
          overHidden: true,
          //sortable: 'name',
        },
      ],
      page: {
        pageNum: 1, //起始位置
        pageSize: 10, //每页条数
        totalCount: null, //总条数
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      visaApplicantInformationQuery(this.SearchObj).then((res) => {
        if (res.code == 200) {
          console.log(res.data.records);
          this.postList = res.data.records;
          this.page.pageNum = res.data.pageNum;
          this.page.pageSize = res.data.pageSize;
          this.page.totalCount = res.data.total;
        }
      });
    },
    getTableChangePageData(obj) {
      this.SearchObj.pageNum = obj.pageNum;
      this.SearchObj.pageSize = obj.pageSize;
      this.getTableData();
    },
    //添加
    handelClickAdd() {
      this.title = '新建资料';
      this.informationBid = '';
      this.$refs.applicantAdd.DialogShow = true;
    },

    //删除
    handleDelete(row) {
      this.$myConfirm
        .showMsgBox({
          title: '提示',
          // confirmBtnText: '一并删除',
          // cancelBtnText: '仅删除账号',
          tips: '',
          content: '确定删除该记录？',
        })
        .then(() => {
          visaApplicantInformationDelete(row.bid).then((res) => {
            if (res.code == '200') {
              this.$msg.success('删除成功！');
              this.getTableData();
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //编辑
    handelClickEdit(row) {
      console.log(row);
      this.informationBid = row.bid;
      this.title = '编辑资料';
      this.$refs.applicantAdd.DialogShow = true;
    },
  },
  components: {
    tablePackaging,
    applicantAdd,
  },
};
</script>

<style>
</style>